import React, { FC } from 'react'

import { DecorationTitle, Tooltip, Txt } from 'src/components/atoms'
import { CommonContentUploadFileList } from 'src/components/organisms'

import { CommonContentPageEntity } from 'src/types'

type Props = {
  commonContent: CommonContentPageEntity
  className?: string
}

export const CommonContentUploadFile: FC<Props> = ({ commonContent, className }) => {
  return (
    <div className={className}>
      <Tooltip
        content={
          <Txt>
            「画像・動画・PDF」をアップロード
            <br />
            または「外部サービス」を設置
          </Txt>
        }
        placement="right"
      >
        <DecorationTitle>ファイルアップロード</DecorationTitle>
      </Tooltip>

      <CommonContentUploadFileList
        commonContentPageId={commonContent.id}
        assets={commonContent.assets}
        className="tw-mt-s2"
      />
    </div>
  )
}
